import { jsx as _jsx } from "react/jsx-runtime";
import { A } from 'shared';
function SkipNavLink({ children, targetId, ...rest }) {
    return (_jsx(A, { variant: "body-large", id: "skip-nav-link", href: `#${targetId}`, ...rest, children: children }));
}
export default SkipNavLink;
